const TENANT_FEATURE = {
  customFeaturedAsset: 'CustomFeaturedAsset',
  redeem: 'RedeemAssets',
  purchase: 'PurchaseAssets',
  kyc: 'KYC',
  restrictedMode: "RestrictedMode"
};

export default TENANT_FEATURE;
